var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMlHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.498,
    height: 26.5,
    viewBox: "0 0 26.498 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #00b0a9;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4 {\r\n        fill: none;\r\n        stroke: #00b0a9;\r\n        stroke-linecap: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10919",
    "data-name": "Group 10919",
    transform: "translate(18516.75 1317.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10918",
    "data-name": "Group 10918",
    transform: "translate(-18516 -1317)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1830",
    "data-name": "Ellipse 1830",
    className: "cls-1",
    cx: 1.751,
    cy: 1.774,
    rx: 1.751,
    ry: 1.774,
    transform: "translate(9.731 8.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7162",
    "data-name": "Path 7162",
    className: "cls-2",
    d: "M23.311,10.4A5.416,5.416,0,0,1,21.2,6.092a5.322,5.322,0,1,1,10.642,0A5.461,5.461,0,0,1,29.732,10.4",
    transform: "translate(-14.974 -0.7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10173",
    "data-name": "Group 10173",
    transform: "translate(0 11.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7163",
    "data-name": "Path 7163",
    className: "cls-3",
    d: "M53.573,1.784A11.334,11.334,0,0,1,58.1,4.427",
    transform: "translate(-38.742 -1.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7164",
    "data-name": "Path 7164",
    className: "cls-4",
    d: "M8.282,0A11.651,11.651,0,0,1,0,11.182",
    transform: "translate(8.282 11.182) rotate(180)"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1064",
    "data-name": "Line 1064",
    className: "cls-4",
    x2: 11.29,
    transform: "translate(-18502.293 -1298.451)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1065",
    "data-name": "Line 1065",
    className: "cls-4",
    x2: 11.29,
    transform: "translate(-18502.293 -1295.226)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1066",
    "data-name": "Line 1066",
    className: "cls-4",
    x2: 11.29,
    transform: "translate(-18502.293 -1292)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlHover);
export default __webpack_public_path__ + "static/media/ml-hover.de06d57c5604bde18930f35a3ce5fba1.svg";
export { ForwardRef as ReactComponent };